/*
 * release-info.component.ts
 * 23-04-2026 - Jelmer Jellema - Spin in het Web B.V.
 * Gegenereerd met Junie (AI), 23-04-2026
 */

import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {releaseInfo} from '../../environments/release';

@Component({
    standalone: true,
    selector: 'release-info',
    templateUrl: './release-info.component.html',
    styleUrls: ['./release-info.component.scss'],
    imports: [CommonModule]
})
export class ReleaseInfoComponent {
    readonly releaseTekst: string = releaseInfo ?? 'release onbekend';
}
